export const Contract = ({
  contractId,
  signatureType,
  signatureDate,
  signatureLinkAvailable,
}) => {
  return Object.freeze({
    contractId,
    signatureType,
    signatureDate: signatureDate ? new Date(signatureDate) : null,
    // The signature URL itself is only delivered on demand (revealSignatureLink), never with the contract
    signatureLinkAvailable: signatureLinkAvailable === true,
  })
}
